/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AppControllerGetHelloQueryResponse } from "../../models/appController/AppControllerGetHello";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { appControllerGetHello } from "../../clients/AppService/appControllerGetHello";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const appControllerGetHelloQueryKey = () => [{
  url: '/api/v1'
}] as const;
export type AppControllerGetHelloQueryKey = ReturnType<typeof appControllerGetHelloQueryKey>;
export function appControllerGetHelloQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = appControllerGetHelloQueryKey();
  return queryOptions<AppControllerGetHelloQueryResponse, ResponseErrorConfig<Error>, AppControllerGetHelloQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return appControllerGetHello(config);
    }
  });
}

/**
 * {@link /api/v1}
 */
export function useAppControllerGetHello<TData = AppControllerGetHelloQueryResponse, TQueryData = AppControllerGetHelloQueryResponse, TQueryKey extends QueryKey = AppControllerGetHelloQueryKey>(options: {
  query?: Partial<QueryObserverOptions<AppControllerGetHelloQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? appControllerGetHelloQueryKey();
  const query = useQuery({
    ...appControllerGetHelloQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}